module.exports = "<div id=\"extr-page\">\n<router-outlet></router-outlet>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/layout/app-layouts/auth-layout.component.html
// module id = ./src/app/shared/layout/app-layouts/auth-layout.component.html
// module chunks = main